import { createContext, useContext, useMemo, useState, type ReactNode } from 'react'

interface DirtyContextValue {
  dirty: boolean
  setDirty: (dirty: boolean) => void
}

const DirtyContext = createContext<DirtyContextValue | null>(null)

export function DirtyProvider({ children }: { children: ReactNode }) {
  const [dirty, setDirty] = useState(false)
  const value = useMemo(() => ({ dirty, setDirty }), [dirty])
  return <DirtyContext.Provider value={value}>{children}</DirtyContext.Provider>
}

export function useDirty() {
  const context = useContext(DirtyContext)
  if (!context) throw new Error('useDirty 必須在 DirtyProvider 內使用')
  return context
}

